import { TranslationEditFormValues, TranslationSearchFormValues } from "./types";

/*-------------------------------------------------------------------------------------------
  SETTING TRANSLATION SEARCH
---------------------------------------------------------------------------------------------*/
export const initialTranslationSearchForm: TranslationSearchFormValues =
{
  search: "",
  languageId: "hr",
};


export const initialTranslationEditForm: TranslationEditFormValues =
{
  translationLanguageId: null,
  key: null,
  value: null,
};


